import { render } from "./BlViewScore.vue?vue&type=template&id=0c4058dc&scoped=true"
import script from "./BlViewScore.vue?vue&type=script&lang=js"
export * from "./BlViewScore.vue?vue&type=script&lang=js"

import "./BlViewScore.vue?vue&type=style&index=0&id=0c4058dc&scoped=true&lang=scss"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4058dc"]])

export default __exports__